// Countries that primarily use miles (imperial system)
const IMPERIAL_COUNTRIES = [
  'united states',
  'usa',
  'u.s.a',
  'u.s.',
  'united kingdom',
  'uk',
  'u.k.',
  'great britain',
  'britain',
  'liberia',
  'myanmar',
  'burma'
];

// US states for detection
const US_STATES = [
  'alabama', 'alaska', 'arizona', 'arkansas', 'california', 'colorado',
  'connecticut', 'delaware', 'florida', 'georgia', 'hawaii', 'idaho',
  'illinois', 'indiana', 'iowa', 'kansas', 'kentucky', 'louisiana',
  'maine', 'maryland', 'massachusetts', 'michigan', 'minnesota',
  'mississippi', 'missouri', 'montana', 'nebraska', 'nevada',
  'new hampshire', 'new jersey', 'new mexico', 'new york',
  'north carolina', 'north dakota', 'ohio', 'oklahoma', 'oregon',
  'pennsylvania', 'rhode island', 'south carolina', 'south dakota',
  'tennessee', 'texas', 'utah', 'vermont', 'virginia', 'washington',
  'west virginia', 'wisconsin', 'wyoming'
];

/**
 * Determines if a location uses the metric system based on the location string
 * @param location - User's location string (city, state, country)
 * @returns true if metric, false if imperial
 */
export const usesMetricSystem = (location: string | null | undefined): boolean => {
  if (!location) return false; // Default to imperial (US is largest user base)
  
  const locationLower = location.toLowerCase();
  
  // Check if location contains any imperial country
  if (IMPERIAL_COUNTRIES.some(country => locationLower.includes(country))) {
    return false;
  }
  
  // Check if location contains any US state
  if (US_STATES.some(state => locationLower.includes(state))) {
    return false;
  }
  
  // Default to metric for rest of world
  return true;
};

/**
 * Converts miles to kilometers
 */
export const milesToKm = (miles: number): number => {
  return Math.round(miles * 1.609344);
};

/**
 * Gets distance options with appropriate units
 * @param isMetric - Whether to use metric system
 * @returns Array of distance options with labels
 */
export const getDistanceOptions = (isMetric: boolean) => {
  if (isMetric) {
    return [
      { value: '25-miles', label: '40 km / 25 mi' },
      { value: '50-miles', label: '80 km / 50 mi' },
      { value: '100-miles', label: '160+ km / 100+ mi' }
    ];
  } else {
    return [
      { value: '25-miles', label: '25 mi / 40 km' },
      { value: '50-miles', label: '50 mi / 80 km' },
      { value: '100-miles', label: '100+ mi / 160+ km' }
    ];
  }
};
